export const CLOUD_TELEPHONY = 'cloud-telephony'
export const CONTACT_CENTRE = `${CLOUD_TELEPHONY}/call-manager-plus`
